"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ToggleSwitchState_1 = require("./ToggleSwitchState");
var styles = require("./ToggleSwitch.css");
var ToggleSwitch = /** @class */ (function (_super) {
    __extends(ToggleSwitch, _super);
    function ToggleSwitch(props) {
        var _this = _super.call(this, props) || this;
        _this.inputId = _this.guid();
        _this.containerId = _this.guid();
        _this.state = new ToggleSwitchState_1.default();
        _this.state.isSwitchOn = _this.props.options.isSwitchOn || false;
        _this.handleKeyPress = _this.handleKeyPress.bind(_this);
        _this.toggleChanged = _this.toggleChanged.bind(_this);
        return _this;
    }
    // componentDidMount() {
    //   if (this.props.options && this.props.options.isSwitchOn) {
    //     this.setState({ isSwitchOn: true });
    //   }
    // } 
    ToggleSwitch.prototype.shouldComponentUpdate = function (newProps) {
        if (newProps.options.isSwitchOn !== undefined
            && newProps.options.isSwitchOn !== null
            && (newProps.options.isSwitchOn !== this.state.isSwitchOn)) {
            this.setState({ isSwitchOn: newProps.options.isSwitchOn });
        }
        return true;
    };
    ToggleSwitch.prototype.handleKeyPress = function (e) {
        if ((this.props.data.disabled === undefined || this.props.data.disabled === false) &&
            (e.key === 'Enter' || e.charCode === 13)) {
            this.props.events.onKeyPress(this.props.data.value);
        }
    };
    ToggleSwitch.prototype.toggleChanged = function () {
        this.setState({ isSwitchOn: !this.state.isSwitchOn });
        this.props.events.onChange(this.props.data.value);
    };
    ToggleSwitch.prototype.render = function () {
        var _a = this.props, className = _a.className, restProps = __rest(_a, ["className"]);
        // Use default as a fallback theme if valid theme is not passed
        var switchTheme = 'default';
        var switchClasses = [
            "switch switch--" + switchTheme,
            className,
        ].join(' ');
        //  `switch-toggle--${this.state.isSwitchOn ? 'on' : 'off'}`
        var outerClassNames = [styles.switchDefault,
            (this.state.isSwitchOn) ? styles.switchIsOn : styles.switchIsOff];
        if (this.props.data.disabled) {
            outerClassNames.push(this.props.options.switchDisableClassName === '' ? styles.switchDisable : this.props.options.switchDisableClassName);
        }
        // ? this.props.options.switchClassName !=='' ? ].join(' ');
        var classNames = [styles.toggleButton,
            (this.state.isSwitchOn) ? styles.toggleButtonPositionRight : styles.toggleButtonPositionLeft].join(' ');
        var ariaText = this.props.data.disabled ? this.props.data.ariaDisabled : (this.state.isSwitchOn) ? 'ON' : 'OFF';
        return (React.createElement("div", { className: styles.flexContainer },
            React.createElement("div", { className: styles.flexChild }, this.renderText()),
            React.createElement("div", { className: styles.flexChild },
                React.createElement("div", { className: outerClassNames.join(' '), "aria-label": ariaText, onClick: this.toggleChanged, tabIndex: 0 },
                    React.createElement("div", { className: classNames })))));
    };
    ToggleSwitch.prototype.renderText = function () {
        var text = this.props.data.value;
        var textClass = this.props.options.switchTextClassName;
        var switchTextClassNames = [styles.switchText, textClass].join(' ');
        return React.createElement("span", { className: switchTextClassNames }, text);
    };
    ToggleSwitch.prototype.guid = function () {
        return "" + this.S4() + this.S4() + "-" + this.S4() + "-" + this.S4() + "-" + this.S4() + "-" + this.S4() + this.S4() + this.S4();
    };
    ToggleSwitch.prototype.S4 = function () {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    };
    return ToggleSwitch;
}(React.Component));
exports.default = ToggleSwitch;
//# sourceMappingURL=ToggleSwitch.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/ToggleSwitch/ToggleSwitch.js
// module id = 1284
// module chunks = 8